/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-25 16:13:37
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 16:25:01
 */
import { ProFormText } from "@ant-design/pro-components";
import { Button, message, Input } from "antd";
import "./index.less";
import ReferralsBg from "@/assets/images/referralsBg.svg";
import AmountIcon from "@/assets/icons/rewords.svg";
import Invite from "@/assets/images/invite.png";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const ReferralsPage = () => {
	const { t } = useTranslation();
	const { currentUser } = useSelector((state: any) => state.global);
	const handleCopy = () => {
		const input = document.getElementById("invite_link") as HTMLInputElement;
		console.log("invite_link", input);
		input.select();
		document.execCommand("copy", true);
		message.success(t("subscription.referrals.left.button.success"));

		//** 展示secret的逻辑 */

		return;
	};
	return (
		<div className="referralsPageContainer">
			<div className="referralsPageContent">
				<div className="pageTitle">{t("subscription.referrals.title")}</div>
				<div className="pageContent">
					<div className="contentLeftCard">
						<div className="cardTop">
							<div className="referralscontent">
								<div className="contentWord">
									<div className="title">{t("subscription.referrals.left.title")}</div>
									<div className="describe">{t("subscription.referrals.left.intro")}</div>
								</div>
								<div className="cardRight">
									<div className="rightImg">
										<img src={Invite} alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="cardBottom">
							<div className="referralsLink">
								<Input
									id="invite_link"
									className="input"
									value={`https://www.adsurgebot.com/register?inviteCode=${currentUser?.invitedCode || ""}`}
								/>
							</div>
							<div className="rightButton">
								<Button
									className="copyButton"
									onClick={() => {
										handleCopy();
									}}
								>
									{t("subscription.referrals.left.button")}
								</Button>
							</div>
						</div>
					</div>
					<div className="contentRightCard">
						<div className="title">{t("subscription.referrals.right.title")}</div>
						<img className="icon" src={AmountIcon} alt="" />
						<div className="mount">
							${currentUser?.rewardPoints || 0} <span className="des">{t("subscription.referrals.right.intro")}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReferralsPage;
